module.exports = __webpack_public_path__ + "img/sonio_pay_logo_no_bg.3a782363.png";